// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-zjCa","icon":"styles_icon__3uBBj"};